import React from 'react';
import { motion } from 'framer-motion';
import { BookOpenIcon, SmartphoneIcon, TvIcon, MonitorIcon, WrenchIcon, SettingsIcon, CheckIcon, GiftIcon } from 'lucide-react';
export function ProductSection() {
  return <section className="bg-zinc-950 py-16 sm:py-24" id="precio" data-id="element-286">
      <div className="max-w-4xl mx-auto px-4" data-id="element-287">
        {/* Product intro */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-288">
          <span className="inline-block bg-emerald-500/10 text-emerald-400 text-sm font-bold px-4 py-2 rounded-full mb-6" data-id="element-289">
            PRESENTAMOS
          </span>
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-black text-white mb-4" data-id="element-290">
            Guía Definitiva: Instala Magis TV en{' '}
            <span className="text-emerald-400" data-id="element-291">Celular y Smart TV</span>
          </h2>
          <p className="text-lg text-zinc-400 max-w-2xl mx-auto" data-id="element-292">
            Paso a Paso 2025 — La única guía visual, actualizada y a prueba de
            errores que te lleva desde cero hasta tener Magis TV funcionando en
            menos de 15 minutos.
          </p>
        </motion.div>

        {/* Modules */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-gradient-to-br from-zinc-900 to-zinc-900/50 border border-zinc-800 rounded-2xl p-6 sm:p-8 mb-8" data-id="element-293">
          <h3 className="text-white font-bold text-xl mb-6 flex items-center gap-2" data-id="element-294">
            <BookOpenIcon className="w-6 h-6 text-emerald-400" data-id="element-295" />
            ¿Qué incluye la guía?
          </h3>

          <div className="space-y-4" data-id="element-296">
            <div className="flex items-start gap-4 p-4 bg-zinc-800/30 rounded-xl" data-id="element-297">
              <div className="w-10 h-10 bg-emerald-500/10 rounded-lg flex items-center justify-center flex-shrink-0" data-id="element-298">
                <span className="text-emerald-400 font-bold" data-id="element-299">1</span>
              </div>
              <div data-id="element-300">
                <h4 className="text-white font-semibold" data-id="element-301">
                  ¿Qué es Magis TV y cómo funciona?
                </h4>
                <p className="text-zinc-400 text-sm" data-id="element-302">
                  Sin tecnicismos, explicado simple
                </p>
              </div>
            </div>

            <div className="flex items-start gap-4 p-4 bg-zinc-800/30 rounded-xl" data-id="element-303">
              <div className="w-10 h-10 bg-emerald-500/10 rounded-lg flex items-center justify-center flex-shrink-0" data-id="element-304">
                <SmartphoneIcon className="w-5 h-5 text-emerald-400" data-id="element-305" />
              </div>
              <div data-id="element-306">
                <h4 className="text-white font-semibold" data-id="element-307">
                  Instalación en celular Android
                </h4>
                <p className="text-zinc-400 text-sm" data-id="element-308">
                  Capturas paso a paso para cualquier modelo
                </p>
              </div>
            </div>

            <div className="flex items-start gap-4 p-4 bg-zinc-800/30 rounded-xl" data-id="element-309">
              <div className="w-10 h-10 bg-cyan-500/10 rounded-lg flex items-center justify-center flex-shrink-0" data-id="element-310">
                <TvIcon className="w-5 h-5 text-cyan-400" data-id="element-311" />
              </div>
              <div data-id="element-312">
                <h4 className="text-white font-semibold" data-id="element-313">
                  Instalación en Smart TV con Android TV
                </h4>
                <p className="text-zinc-400 text-sm" data-id="element-314">
                  Método Downloader incluido
                </p>
              </div>
            </div>

            <div className="flex items-start gap-4 p-4 bg-zinc-800/30 rounded-xl" data-id="element-315">
              <div className="w-10 h-10 bg-amber-500/10 rounded-lg flex items-center justify-center flex-shrink-0" data-id="element-316">
                <MonitorIcon className="w-5 h-5 text-amber-400" data-id="element-317" />
              </div>
              <div data-id="element-318">
                <h4 className="text-white font-semibold" data-id="element-319">
                  Fire TV Stick y Chromecast con Google TV
                </h4>
                <p className="text-zinc-400 text-sm" data-id="element-320">
                  Instrucciones específicas para cada dispositivo
                </p>
              </div>
            </div>

            <div className="flex items-start gap-4 p-4 bg-zinc-800/30 rounded-xl" data-id="element-321">
              <div className="w-10 h-10 bg-red-500/10 rounded-lg flex items-center justify-center flex-shrink-0" data-id="element-322">
                <WrenchIcon className="w-5 h-5 text-red-400" data-id="element-323" />
              </div>
              <div data-id="element-324">
                <h4 className="text-white font-semibold" data-id="element-325">
                  Los 5 errores más comunes
                </h4>
                <p className="text-zinc-400 text-sm" data-id="element-326">
                  Y cómo resolverlos al instante
                </p>
              </div>
            </div>

            <div className="flex items-start gap-4 p-4 bg-zinc-800/30 rounded-xl" data-id="element-327">
              <div className="w-10 h-10 bg-purple-500/10 rounded-lg flex items-center justify-center flex-shrink-0" data-id="element-328">
                <SettingsIcon className="w-5 h-5 text-purple-400" data-id="element-329" />
              </div>
              <div data-id="element-330">
                <h4 className="text-white font-semibold" data-id="element-331">
                  Configuración para máxima calidad
                </h4>
                <p className="text-zinc-400 text-sm" data-id="element-332">
                  Ajustes recomendados para mejor experiencia
                </p>
              </div>
            </div>
          </div>
        </motion.div>

        {/* Bonus */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-gradient-to-r from-amber-500/10 to-orange-500/10 border border-amber-500/30 rounded-2xl p-6 sm:p-8 mb-10" data-id="element-333">
          <div className="flex items-center gap-3 mb-4" data-id="element-334">
            <GiftIcon className="w-6 h-6 text-amber-400" data-id="element-335" />
            <span className="text-amber-400 font-bold text-lg" data-id="element-336">
              BONUS INCLUIDO
            </span>
          </div>
          <h4 className="text-white font-bold text-xl mb-2" data-id="element-337">
            Checklist de instalación imprimible
          </h4>
          <p className="text-zinc-400" data-id="element-338">
            Para no perderse ni un paso — marca cada item mientras avanzas
          </p>
        </motion.div>

        {/* What you get summary */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-zinc-900/50 border border-zinc-800 rounded-2xl p-6 sm:p-8 mb-8" data-id="element-339">
          <h3 className="text-white font-bold text-xl mb-6 text-center" data-id="element-340">
            Lo que obtienes hoy:
          </h3>
          <div className="grid sm:grid-cols-2 gap-4" data-id="element-341">
            <div className="flex items-center gap-3" data-id="element-342">
              <CheckIcon className="w-5 h-5 text-emerald-500 flex-shrink-0" data-id="element-343" />
              <span className="text-zinc-300" data-id="element-344">Guía completa en PDF</span>
            </div>
            <div className="flex items-center gap-3" data-id="element-345">
              <CheckIcon className="w-5 h-5 text-emerald-500 flex-shrink-0" data-id="element-346" />
              <span className="text-zinc-300" data-id="element-347">Capturas de pantalla reales</span>
            </div>
            <div className="flex items-center gap-3" data-id="element-348">
              <CheckIcon className="w-5 h-5 text-emerald-500 flex-shrink-0" data-id="element-349" />
              <span className="text-zinc-300" data-id="element-350">6 módulos paso a paso</span>
            </div>
            <div className="flex items-center gap-3" data-id="element-351">
              <CheckIcon className="w-5 h-5 text-emerald-500 flex-shrink-0" data-id="element-352" />
              <span className="text-zinc-300" data-id="element-353">Solución de errores comunes</span>
            </div>
            <div className="flex items-center gap-3" data-id="element-354">
              <CheckIcon className="w-5 h-5 text-emerald-500 flex-shrink-0" data-id="element-355" />
              <span className="text-zinc-300" data-id="element-356">
                Checklist imprimible (bonus)
              </span>
            </div>
            <div className="flex items-center gap-3" data-id="element-357">
              <CheckIcon className="w-5 h-5 text-emerald-500 flex-shrink-0" data-id="element-358" />
              <span className="text-zinc-300" data-id="element-359">Acceso inmediato</span>
            </div>
          </div>
        </motion.div>

        {/* PRICING BLOCK */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-gradient-to-br from-emerald-500/15 via-zinc-900 to-cyan-500/10 border-2 border-emerald-500/40 rounded-2xl p-8 sm:p-10 text-center" data-id="element-360">
          {/* Discount badge */}
          <div className="inline-flex items-center gap-2 bg-amber-500/20 border border-amber-500/40 text-amber-400 text-sm font-bold px-4 py-1.5 rounded-full mb-6" data-id="element-361">
            🔥 PRECIO CON DESCUENTO — OFERTA LIMITADA
          </div>

          {/* Price */}
          <div className="mb-4" data-id="element-362">
            <p className="text-zinc-500 text-lg line-through mb-1" data-id="element-363">$ 30.000</p>
            <p className="text-6xl sm:text-7xl font-black text-white leading-none" data-id="element-364">
              $ <span className="text-emerald-400" data-id="element-365">15.000</span>
            </p>
            <p className="text-zinc-400 text-sm mt-2" data-id="element-366">pesos argentinos</p>
          </div>

          {/* One-time badge */}
          <div className="inline-flex items-center gap-2 bg-emerald-500/10 border border-emerald-500/30 text-emerald-400 font-bold px-5 py-2 rounded-full text-base mb-6" data-id="element-367">
            ✅ PAGO ÚNICO — Sin suscripciones. Sin renovaciones.
          </div>

          <p className="text-zinc-400 text-sm mb-8" data-id="element-368">
            Pagás una sola vez y la guía es tuya para siempre.
          </p>

          <a id="checkout-btn" href="https://argrutinas.com/cart/42978257207505:1" target="_blank" rel="noopener noreferrer" onClick={() => {
          if (typeof (window as any).fbq === 'function') {
            ;
            (window as any).fbq('track', 'AddToCart');
          }
        }} className="group inline-flex items-center justify-center gap-3 bg-gradient-to-r from-emerald-500 to-emerald-400 hover:from-emerald-400 hover:to-emerald-300 text-black font-black text-lg sm:text-xl px-8 sm:px-12 py-4 sm:py-5 rounded-xl transition-all duration-300 hover:scale-105 hover:shadow-2xl hover:shadow-emerald-500/30 w-full sm:w-auto" data-id="element-369">
            <span data-id="element-370">QUIERO LA GUÍA AHORA →</span>
          </a>

          <p className="text-zinc-600 text-xs mt-4" data-id="element-371">
            🔒 Pago seguro · Acceso inmediato · Garantía 100%
          </p>
        </motion.div>
      </div>
    </section>;
}